import React from "react";
import { Link, useLocation } from "react-router-dom";
import ArrowLeft from "mdi-material-ui/ArrowLeft";
import { pathWithPreservedSearch } from "src/@core/utils/urlQueryPreservation";

/******************************************************************
 * ##: BackToCourses
 * "Voltar aos cursos" link shown in the account pages (perfil /
 * compras) head, next to the title. Navigates to /home preserving
 * the current query (same target as the course player back button).
 * @returns {JSX.Element} - a `.spv3-btn` link to the courses home
 * History:
 * 07-10-2026: Created
 ******************************************************************/
const BackToCourses = () => {
  const location = useLocation();
  return (
    <Link className="spv3-btn spv3-btn--ghost spv3-pagehead__back" to={pathWithPreservedSearch("/home", location.search)}>
      <ArrowLeft />
      Voltar
    </Link>
  );
};

export default BackToCourses;
